import axios from "axios";

export const state = {
    groupaccounts: [],
};

export const getters = {
    groupaccounts: state => state.groupaccounts,
};

export const mutations = {
    setGroupAccounts(state, newValue) {
        state.groupaccounts = newValue
    },
};

export const actions = {
    fetchGroupAccounts({ commit }) {
        axios.get('/groupaccounts').then(res => {
            commit('setGroupAccounts', res.data.accounts)
        })
    },
};
